import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function GovernanceData() {
    const [docs, setDocs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        setLoading(true);
        setError(null);
        try {
            const url = process.env.REACT_APP_API + "/viewweb/governance";
            const res = await axios.get(url, { credentials: true });
            if (!res.status === 200) throw new Error(`Failed to fetch documents: ${res.status} ${res.statusText}`);
            setDocs(Array.isArray(res?.data?.data) ? res?.data?.data : []);
        } catch (err) {
            setError(err.message || "Unknown error");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="max-w-5xl mx-auto p-4">
            <h2 className="text-2xl font-semibold mb-4">Governance</h2>

            {loading && <div className="py-8 text-center text-sm text-gray-600">Loading documents...</div>}
            {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 p-3 rounded mb-4">{error}</div>
            )}

            {!loading && !error && docs.length === 0 && (
                <div className="text-gray-500 py-8 text-center">No documents found.</div>
            )}

            {docs.length > 0 && (
                <div className="overflow-x-auto border rounded">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-4 py-2 text-center text-sm font-semibold text-gray-700">#</th>
                                <th className="px-4 py-2 text-center text-sm font-semibold text-gray-700">Title</th>
                                <th className="px-4 py-2 text-center text-sm font-semibold text-gray-700">File</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 bg-white">
                            {docs.map((doc, idx) => (
                                <tr key={doc.id} className="hover:bg-gray-50 cursor-pointer">
                                    <td className="px-4 py-2 text-sm text-gray-700">{idx + 1}</td>
                                    <td className="px-4 py-2 text-sm font-medium text-gray-900">{doc.title}</td>
                                    <td className="px-4 py-2 text-center flex justify-center">
                                        <Link target="_blank" to={doc.pdf}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="w-6 h-6 text-red-500"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={1.5}
                                                    d="M12 2l4 4h4v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h6z"
                                                />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v6" />
                                            </svg>
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

        </div>
    );
}
